export const toggleDot = (nav, index, color) => {
  const dots = Array.from(nav.children);
  dots.forEach((dot) => {
    dot.classList.remove("active");
    dot.removeAttribute("style");
    const button = dot.querySelector("button")
    if (button) {
      button.removeAttribute("aria-current");
    }
  });
  const normalizedIndex = index < 0 ? 0 : index >= dots.length ? dots.length - 1 : index;
  const dot = dots[normalizedIndex];
  if (dot) {
    dot.classList.add("active");
    if (color) {
      dot.setAttribute("style", `background-color: ${color}`);
    }
    const button = dot.querySelector("button")
    if (button) {
      button.setAttribute("aria-current", "true");
    }
  }
};
